import { Injectable } from '@angular/core';
import { del, get, keys, set } from 'idb-keyval';

/** Injectable boundary for browser storage failures and asynchronous log writes. */
@Injectable({ providedIn: 'root' })
export class LogStorageService {
  keys(): Promise<IDBValidKey[]> {
    return keys();
  }

  get(key: string): Promise<unknown> {
    return get(key);
  }

  set(key: string, value: unknown): Promise<void> {
    return set(key, value);
  }

  delete(key: string): Promise<void> {
    return del(key);
  }
}
